import { Component, ElementRef, Input, OnInit, QueryList, ViewChildren } from "@angular/core";
import { MybuilkService } from "../../../../service/api/builk/mybuilk.service";
import { LocalStorageService } from "angular-2-local-storage";
@Component({
  selector: "feed-comment",
  templateUrl: "./comment.component.html",
  styleUrls: ["../mybuilk.component.scss"]
})
export class CommentComponent implements OnInit {
  @Input() post: any;
  @ViewChildren("commentTextArea") commentTextArea: QueryList<ElementRef>;
  commentMessage: string;
  editCommentMessage: any = [];
  currUser: any;
  userCulture: string;
  constructor(
    private mybuilkService: MybuilkService,
    private localStorageService: LocalStorageService,
  ) {
    this.userCulture = this.localStorageService.get("userCulture");
  }

  ngOnInit(): void {
  }

  deleteComment(post: any, comment: any, isAd: boolean): void {
    const data: any = {
      id: post.id,
      timestamp: comment.timestamp,
      userId: post.userId,
      isAd
    };
    this.mybuilkService.deleteComment(data)
      .subscribe(response => {
        this.post = this.mybuilkService.initialPost(response);
      }, err => { });
  }

  focusComment(): void {
    this.commentTextArea.toArray()[0].nativeElement
      .focus();
  }

  readMore(obj: any): void {
    obj = this.mybuilkService.readMore(obj);
  }

  dateParse(text: string) {
    return this.mybuilkService.dateParse(text);
  }

  addAnchorsToText(text) {
    return this.mybuilkService.addAnchorsToText(text);
  }
}
